var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('auth-layout',[_c('div',{staticClass:"auth-error"},[_c('sep',{attrs:{"name":"XL"}}),_c('typo',{attrs:{"name":"title-18-bold"}},[_vm._v(" "+_vm._s(_vm.error)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }